import { Component } from '~/types'
import { getCookie, setCookie } from '../utils/cookies'

const component: Component = (ref) => {
  if (!ref.storeSelector) return

  ref.storeSelector.forEach(element => {
    // Only proceed if the store selector is enabled
    if (element.dataset.enabled !== 'true') return

    // Check for an existing geo location cookie first
    const geoCheckCookie = getCookie('geo_check')
    const geoCountryCookie = getCookie('geo_country')

    // If we've already checked within 24 hours, use the cached result
    if (geoCheckCookie) {
      if (geoCountryCookie) {
        checkGeo(geoCountryCookie)
      }
      return
    }

    // We haven't checked in the last 24 hours, so proceed with API call
    const apiKey = element.querySelector('.js-api')?.dataset.api
    if (!apiKey) return

    fetch(`https://api.ipgeolocation.io/ipgeo?apiKey=${apiKey}`)
      .then((response) => response.json())
      .then((data) => {
        const countryCode = data.country_code2

        // Store the country code for 24 hours
        setCookie('geo_country', countryCode, 1)

        // Set a flag that we've checked geolocation within 24 hours
        setCookie('geo_check', 'true', 1)

        // Proceed with geo check
        checkGeo(countryCode)
      })
      .catch(error => {
        console.error('Error fetching geolocation:', error)
        // Set the check cookie anyway to avoid repeated failed calls
        setCookie('geo_check', 'true', 1)
      })

    // Check GEO
    function checkGeo(countryCode: string) {
      // If user has already dismissed the popup, don't show it again
      if (getCookie('geo_hide')) return

      const thisCode = element.dataset.thisCode
      const isInternational = element.dataset.isInternational === 'true'

      // If this is the Danish store
      if (!isInternational) {
        // Show popup for non-Danish visitors
        if (countryCode !== thisCode) {
          showPopup()
        }
      }
      // If this is the International store
      else {
        // Show popup only for Danish visitors
        if (countryCode === element.dataset.altCode) {
          showPopup()
        }
      }
    }

    // Show Popup
    function showPopup() {
      const suggestionLink = element.querySelector<HTMLAnchorElement>('.js-link-suggestion')

      if (!suggestionLink) return

      suggestionLink.href = element.dataset.altUrl || ''
      element.classList.add('is-open')
    }

    // Dismiss Popup
    const thisLink = element.querySelector<HTMLElement>('.js-link-this')
    if (thisLink) {
      thisLink.addEventListener('click', (e) => {
        e.preventDefault()
        element.classList.remove('is-open')
        setCookie('geo_hide', 'true', 1)
      })
    }

    // Close button functionality
    const closeButton = element.querySelector<HTMLElement>('.js-close')
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        element.classList.remove('is-open')
        setCookie('geo_hide', 'true', 1)
      })
    }
  })
}

export default component
